import { UserCurrent } from "@/types/user"
import axiosInstance from "./api"

export const getUserCurrent = async (): Promise<UserCurrent> => {
  const response = await axiosInstance.get<UserCurrent>('User/Current')
  return response.data
}